{
  "assetContainerEvent": {
    "types": {
      "arrived": "En Patio",
      "arrivedWaiting": "En Patio/Esperando",
      "loading": "Cargando",
      "loadingComplete": "Carga Completa",
      "unloading": "Descargando",
      "unloadingComplete": "Descarga Completa",
      "readyForPickup": "Listo para Recoger",
      "departed": "Salió del Patio",
      "inoperable": "Inoperable",
      "missing": "Ausente",
      "inTransit": "En tránsito"
    }
  },
  "assetVisitYardEvent": {
    "Arrived": "Llegado",
    "Docked": "En Muelle",
    "Parked": "Estacionado",
    "Unassigned": "No asignado",
    "Dropped": "Dejado",
    "Hooked": "Enganchado",
    "Appointment Linked": "Cita vinculada",
    "Appointment Unlinked": "Cita desvinculada",
    "Status Updated": "Estado actualizado"
  },
  "assetContainerTypes": {
    "trailer": "Remolque",
    "container": "Contenedor",
    "oversized": "Sobredimensionado",
    "chassis": "Chasis",
    "reefer": "Refrigerado",
    "other": "Otro"
  },
  "assetVisitTypes": {
    "live": "En Vivo",
    "drop": "Desenganche",
    "pickup": "Enganche",
    "dropHook": "Desenganche y Enganche"
  },
  "assetVisitDirections": {
    "inbound": "Entrada",
    "outbound": "Salida",
    "inboundAndOutbound": "Ent. y Sal."
  },
  "loadTypeDirections": {
    "inbound": "Entrada",
    "outbound": "Salida",
    "inOut": "Entrada y salida",
    "load": "Carga",
    "unload": "Descarga",
    "dropOff": "Entrega",
    "pickUp": "Recogida",
    "dropAndHook": "Entrega y enganche",
    "inboundAndOutbound": "Entrada y salida"
  },
  "loadTypeOperations": {
    "live": "En vivo",
    "drop": "Entrega",
    "other": "Otro"
  },
  "loadTypeTypes": {
    "standard": "Estándar",
    "preparation": "Preparación"
  },
  "altAssetVisitTypes": {
    "unknown": "Desconocido"
  },
  "assetContainerStates": {
    "full": "Lleno",
    "empty": "Vacío",
    "partiallyLoaded": "Parcialmente Cargado"
  },
  "spotStatuses": {
    "open": "abierto",
    "closed": "cerrado",
    "assigned": "asignado",
    "inTransit": "en tránsito",
    "reservedManual": "reservado",
    "reservedAutomated": "reservado",
    "unknown": "desconocido"
  },
  "spotTypes": {
    "parking": "estacionamiento",
    "docking": "muelle de carga"
  },
  "labels": {
    "licensePlate": "Placa",
    "dotNumber": "Número DOT"
  },
  "messages": {
    "unknownCompany": "Empresa desconocida",
    "unhooked": "Desenganchado",
    "noInformationAvailable": "No hay información disponible",
    "noVisitFound": "No se encontró la visita",
    "notInformed": "No informado",
    "waitingAssignment": "Esperando asignación",
    "failedToLoadSpotDetails": "No se pudieron cargar los detalles del lugar",
    "retry": "Reintentar",
    "blockedUntilSpotIsOpen": "Bloqueado hasta que {spot} esté disponible",
    "blockReasons": {
      "reservedByOther": "El lugar de destino está **reservado** para la **Tarea de movimiento #{taskNumber}**.",
      "reservedByOtherGeneric": "El lugar de destino está **reservado**.",
      "destinationClosed": "El lugar de destino está **cerrado**.",
      "destinationOccupied": "El lugar de destino está **ocupado** por otro activo.",
      "anotherAssetInTransitForDestination": "**{assetCode}** ya está en tránsito hacia este lugar.",
      "assetInTransitElsewhere": "El activo ya está siendo movido por otra tarea de movimiento."
    }
  }
}
